import { createContext, useContext, type ReactNode } from 'react';
import { useInboxListState } from '../hooks/useInboxListState';

type InboxListValue = ReturnType<typeof useInboxListState>;

const Ctx = createContext<InboxListValue | null>(null);

const EMPTY_INBOX_LIST: InboxListValue = {
  items: [],
  pending: null,
  reload: () => undefined,
  snooze24h: async () => undefined,
  dismiss: async () => undefined,
  openEntity: () => undefined,
  markSeen: async () => undefined,
  isJobSeen: () => false,
};

export function InboxListProvider({ children }: { children: ReactNode }) {
  const value = useInboxListState();
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useInboxList(): InboxListValue {
  return useContext(Ctx) ?? EMPTY_INBOX_LIST;
}
